export const ITEM_STOCK_TRANSFER_HISTORY = 'ITEM_STOCK_TRANSFER_HISTORY';
export const ITEM_STOCK_TRANSFER_HISTORY_SUCCESS = 'ITEM_STOCK_TRANSFER_HISTORY_SUCCESS';
export const ITEM_STOCK_TRANSFER_HISTORY_FAILED = 'ITEM_STOCK_TRANSFER_HISTORY_FAILED';

export const STOCK_TRANSFER_HISTORY = 'STOCK_TRANSFER_HISTORY';
export const STOCK_TRANSFER_HISTORY_SUCCESS = 'STOCK_TRANSFER_HISTORY_SUCCESS';
export const STOCK_TRANSFER_HISTORY_FAILED = 'STOCK_TRANSFER_HISTORY_FAILED';

